export default class NodesCreator {
    // Public:
    compute(items) {
        this.nodes = [];
        this.createNodes(items, null);
        return this.nodes;
    }

    // Private:
    createNodes(items, parent) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            this.createNode(item, parent);
            this.createChildrenNodes(item);
        }
    }

    createChildrenNodes(item) {
        const children = item.children;
        if (children) {
            this.createNodes(children, item);
        }
    }

    createNode(item, parent) {
        const id = this.computeId(item);
        const name = item["name"];
        const img = item["media_url"];
        const type = this.getType(parent);
        const ownerId = this.getParentId(parent);
        const group = this.getGroup(item, parent);
        const weight = item["weight"];

        let node = {
            id: id,
            type: type,
            label: name,
            group: [group], // !! Rename to GROUPS !!
            ownersIds: ownerId ? [ownerId] : [],
            img: img,
            original: item, // !! Rename to originalItem !!
            weight: weight,
        };
        this.nodes.push(node);
    }

    getType(parent) {
        return parent ? "slave" : "master";
    }

    getParentId(parent) {
        return parent ? this.computeId(parent) : null;
    }

    computeId(item) {
        return "Item-" + String(item["name"]) + "-" + item["node"];
    }

    getGroup(item, parent) {
        return parent ? parent.id : item.id;
    }
}
